import r from "./index80.js";
import p from "./index57.js";
import l from "./index53.js";
import m from "./index55.js";
import a from "./index63.js";
import o from "./index64.js";
function s(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new m(null, e);
}
function y(e) {
  return s(e), e.headers = a.from(e.headers), e.data = r.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), o.getAdapter(e.adapter || l.adapter, e)(e).then(
    function(t) {
      s(e), e.response = t;
      try {
        t.data = r.call(e, e.transformResponse, t);
      } finally {
        delete e.response;
      }
      return t.headers = a.from(t.headers), t;
    },
    function(t) {
      if (!p(t) && (s(e), t && t.response)) {
        e.response = t.response;
        try {
          t.response.data = r.call(
            e,
            e.transformResponse,
            t.response
          );
        } finally {
          delete e.response;
        }
        t.response.headers = a.from(t.response.headers);
      }
      return Promise.reject(t);
    }
  );
}
export {
  y as default
};
